import React, { useState } from "react";
import { FunctionComponent } from "react";
import Container from "../../components/Container.tsx";
import Navbar from "../../components/Navbar.tsx";
import Footer from "../../components/Main/Footer.tsx";
import MyAccount from "../../components/Admin/MyAccount.tsx";
import Breadcrumb from "../../components/Breadcrumb.tsx";
import Sidebar from "../../components/Admin/Sidebar.tsx";
import AdminContainer from "../../components/AdminContainer.tsx";
import Orders from "../../components/Admin/Orders.tsx";
import Addresses from "../../components/Admin/Addresses.tsx";
import { useSelector } from "react-redux";
import NavbarMobile from "../../components/NavbarMobile.tsx";

const OrdersPage = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1180);
  const reduxStateLanguage = useSelector((state: any) => state.language.value);

  return (
    <Container>
      {isMobile ? (
        <NavbarMobile lang={reduxStateLanguage} />
      ) : (
        <Navbar lang={reduxStateLanguage} />
      )}
      <Breadcrumb tab={"Addresses"} />
      <AdminContainer>
        <Sidebar activeTabs={2} />
        <Addresses />
      </AdminContainer>
      <Footer />
    </Container>
  );
};

export default OrdersPage;
